// Verification page translations
export default {
  title: "Account Verification",
  subtitle: "Please complete account verification to continue",
  emailVerification: "Email Verification",
  phoneVerification: "Phone Verification",
  twoFactorAuth: "Two-Factor Authentication",
  sendVerificationEmail: "Send Verification Email",
  sendVerificationSMS: "Send SMS Code",
  resendCode: "Resend Code",
  verifyButton: "Verify",
  skipVerification: "Skip Verification",
  verificationSuccess: "Verification successful",
  verificationFailed: "Verification failed",
  codeIncorrect: "Verification code is incorrect",
  form: {
    emailCode: "Email Verification Code",
    smsCode: "SMS Verification Code",
    authCode: "Authentication Code",
    emailCodeRequired: "Please enter email verification code",
    smsCodeRequired: "Please enter SMS verification code",
    authCodeRequired: "Please enter authentication code",
    codeFormat: "Please enter {length}-digit verification code",
  },
  tips: {
    emailSent: "Verification email has been sent to {email}",
    smsSent: "Verification code has been sent to {phone}",
    checkSpam: "If you don't receive the email, please check your spam folder",
    codeExpiry: "Verification code will expire in {minutes} minutes",
  },
};
